import React, { useEffect } from "react";
import PropTypes from "prop-types";
import ReactDOM from "react-dom";

const BaseModal = ({
  isOpen,
  isFetching,
  onClose,
  children,
  width = "400px",
  height = "400px",
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return ReactDOM.createPortal(
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="fixed inset-0 bg-black opacity-50"
        onClick={!isFetching ? onClose : undefined}
      />
      <div
        className="bg-white max-h-[80vh] overflow-hidden rounded-7 shadow-lg z-10 p-[20px]"
        style={{ width, height }}
      >
        {children}
      </div>
    </div>,
    document.body
  );
};

BaseModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
  width: PropTypes.string,
  height: PropTypes.string,
};

export default BaseModal;
